import A from "./ghl-ui.es735.js";
import g from "./ghl-ui.es736.js";
import w from "./ghl-ui.es737.js";
import R from "./ghl-ui.es738.js";
import S from "./ghl-ui.es739.js";
import c from "./ghl-ui.es740.js";
var C = 200;
function x(h, n, l) {
  var m = -1, o = g, t = h.length, e = !0, f = [], i = f;
  if (l)
    e = !1, o = w;
  else if (t >= C) {
    var p = n ? null : S(h);
    if (p)
      return c(p);
    e = !1, o = R, i = new A();
  } else
    i = n ? [] : f;
  i:
    for (; ++m < t; ) {
      var r = h[m], s = n ? n(r) : r;
      if (r = l || r !== 0 ? r : 0, e && s === s) {
        for (var u = i.length; u--; )
          if (i[u] === s)
            continue i;
        n && i.push(s), f.push(r);
      } else
        o(i, s, l) || (i !== f && i.push(s), f.push(r));
    }
  return f;
}
export {
  x as default
};
